// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.
import styled from '@emotion/styled';
import { Card } from '@kintent/glide';

export const Section = styled(Card)`
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  background-color: rgba(255, 255, 255, 0.5);

  display: flex;
  flex-direction: column;
  gap: 36px;

  & .leadership-section-title {
    font-weight: 600;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(200px, 1fr));
  column-gap: 36px;
  row-gap: 24px;

  & .enterprise-leader-avatar {
    align-self: center;
  }

  & .enterprise-leader-info {
    align-self: center;

    & span:nth-child(2) {
      font-weight: 500;
      font-family: Lato;
    }
  }
`;
